<template>
<div>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
             <v-flex xs11>
              <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white" text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white"  text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
           </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-progress-linear v-show="this.loaders.detail_loader" slot="progress" color="blue" indeterminate></v-progress-linear>
            <v-flex xs10>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2 header">
                            <v-flex xs6 sm8>
                                <p class="text-color">User Detail</p><p class="err">{{ error }}</p>
                            </v-flex>
                            <v-flex xs6 sm4>
                                <!-- <v-btn small color="error" class="float_right ml-2"  @click="change_password_dialog_box=true">Change Password</v-btn> -->
                                <v-btn small color="error" class="float_right ml-2" @click="delete_user_dialog_box=true">Delete</v-btn>
                                <v-btn small color="primary" class="float_right" :to="`/users/edit/${user_details.id}`">Edit</v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex sm12 md10>
                                <v-card-text>
                                    
                                <v-layout row wrap>
                                    <!-- <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>First Name</v-list-item-subtitle>
                                            <v-list-item-title v-if="user_details.first_name!= null" class="pt-1">{{user_details.first_name}}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Last Name</v-list-item-subtitle>
                                            <v-list-item-title v-if="user_details.first_name!=null" class="pt-1">{{user_details.last_name}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense class="mt-2">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Email</v-list-item-subtitle>
                                            <v-list-item-title v-if="user_details.email!=null" class="pt-1">{{user_details.email}}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Mobile</v-list-item-subtitle>
                                            <v-list-item-title v-if="user_details.mobile!=null" class="pt-1">{{user_details.mobile}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item> -->
                                     <v-list-item dense class="mt-2">
                                        <v-list-item-content v-if="user_details!=null">
                                            <v-list-item-subtitle>User Name</v-list-item-subtitle>
                                            <v-list-item-title v-if="user_details.username!=null" class="pt-1">{{user_details.username}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense class="mt-2" v-if='user_details.roles!=null'>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Role</v-list-item-subtitle>
                                            <v-list-item-title v-if="user_details.roles" class="pt-1">{{user_details.roles[0].display_name}}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-content v-if='user_details.roles!=null'>
                                            <v-list-item-subtitle>Updated At</v-list-item-subtitle>
                                            <v-list-item-title v-if="user_details.roles" class="pt-1">{{formatDateTime(user_details.updated_at)}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense class="mt-2" v-if='user_details!=null'>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Created At</v-list-item-subtitle>
                                            <v-list-item-title v-if="user_details.created_at!=null" class="pt-1">{{formatDateTime(user_details.created_at)}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    
                                </v-layout>
                               
                                </v-card-text>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    <!-- Delete User model -->
    <v-dialog v-model="delete_user_dialog_box" scrollable :overlay="false" max-width="600px" transition="dialog-transition">
        <v-card>
            <v-form>
                <v-card-text>
                    <v-card-title primary-title>
                        <span class="headline">Are you sure you want to delete this User ?</span>
                    </v-card-title>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="confirmDeleteUser">Delete</v-btn>
                    <v-btn color="black" text small @click="delete_user_dialog_box=false">Cancel</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <!--Change Password -->
    <v-dialog v-model="change_password_dialog_box" scrollable :overlay="false" max-width="600px" transition="dialog-transition">
        <v-form @submit.prevent="validateBeforeSubmit('updatePassword')" data-vv-scope="updatePassword" id="updatePassword" ref="update_form">
                <v-card> 
                    <v-card-text>
                        <v-layout row wrap class="field_wrapper">
                            <v-flex xs12 md3 lg3 sm3 >
                            <label>Old Password <span style="color:red">*</span></label>
                            <v-text-field
                           name="Password"
                           solo flat
                           type="password"
                           v-model="user_details.old_password"
                           v-validate="'required'"
                           :error-messages="errors.collect('updatePassword.Password')"
                            ></v-text-field>
                            <span v-if="is_wrong_password" style="color:red;">{{password_message}}</span>
                         </v-flex> 
                            <v-flex xs12 md3 lg3 sm3 >
                                    <label>New Password <span style="color:red">*</span></label>
                                    <v-text-field
                                       name="New Password"
                                       solo flat
                                       type="password"
                                       v-model="user_details.new_password"
                                       v-validate="'required'"
                                        :error-messages="errors.collect('updatePassword.New Password')"
                                    ></v-text-field>
                                     </v-flex> 
                                     <v-flex xs12 md3 lg3 sm3 >
                                        <label>Confirm Password <span style="color:red">*</span></label>
                                        <v-text-field
                                       name="Confirm Password"
                                       type="password"
                                       solo flat
                                       v-model="confirm_password"
                                       v-validate="'required'"
                                      :error-messages="errors.collect('updatePassword.Confirm Password')"
                                      :disabled="user_details.new_password == ''"
                                      :rules="[() => (confirm_password != '' && (user_details.new_password == confirm_password)) || 'Password does not Match']"
                                 ></v-text-field>
                            </v-flex> 
                             <v-flex xs12 md2 lg2 sm2 >
                                <v-btn class="my-4" color="primary" type="submit" >Update</v-btn>
                             </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
           </v-form>
    </v-dialog>
</div>
</template>

<script>
export default {
    methods: {
        getUserDetails() {
            this.loaders.detail_loader = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/users/` + this.$route.params.id).then(response => {
               this.loaders.detail_loader=true;
                    if (response.data.status == 1) {
                        this.user_details = response.data.user_details;
                        console.log(this.user_details);
                        this.loaders.detail_loader = false;
                       
                    }if(response.data.status == 0){
                    this.error = "Error Occured";
                     this.loaders.detail_loader=false;
                }
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {

                });
        },
        updatePassword:function(){        
        axios.post(`${process.env.VUE_APP_API_URL}/api/updatePassword`, this.user_object).then((response)=>{
                    
            this.response_message = response.data.message;
            this.response_status =  response.data.status;
          if(this.response_status == 2)
          {

            this.is_wrong_password = true;
            this.password_message =  response.data.message;
          }
          else if(this.response_status == 1)
          {
            // this.snackBar.message  = response.data.message;
            this.is_wrong_password = false;
            // this.snackBar.show =true;
            this.user_details = {};
            this.confirm_password = "";
            this.$refs.update_form.resetValidation();
           
          }       

        }).catch((error)=>{
                
        }).finally(()=>{
            this.submit_loader =  false;
        });

        },

        confirmDeleteUser: function () {
            axios
                .post(`${process.env.VUE_APP_API_URL}/api/users/` + this.$route.params.id + `/delete`).then((response) => {
                    if (response.data.status == 1) {

                        this.delete_user_dialog_box = false;
                        this.$router.push({name: 'users', params:{
                        success_message:'User Deleted Successfully'
                    }});
                
                    }if(response.data.status == 0){
                    this.error = "Error Occured";
                }

                }).catch((error) => {
                    console.log(error);

                }).finally(() => {
                    {

                    }
                });
        },
    },
    data() {
        return {
            error:'',
            user_details: {},
            loaders: {
                detail_loader: false,
            },
            confirm_password:"",
            delete_user_dialog_box: false,
            user_related_registrations: [],
            user_headers: [{
                    text: 'Name',
                    align: 'left',
                    value: 'username',
                sortable: false,
                },
                {
                    text: 'Mobile',
                    value: 'mobile',
                    sortable: false,
                },
                {
                    text: 'Email',
                    value: 'email',
                    sortable: false,
                },
                {
                    text: 'Action',
                    value: '',
                    sortable: false,
                },
            ],
            is_loading: false,
            total_items: 10,
            options: {},
            to_be_deleted_user: {},
            change_password_dialog_box:false,
            is_wrong_password:false,
            message:'',
            alert: false,
            alert_error:false
        }
    },
    mounted() {
         if(this.$route.params.success_message!=null) 
        {    this.alert=true;
            this.message = this.$route.params.success_message;
        }
        this.getUserDetails();
    }
};
</script>
